/**
 * Google tag (gtag.js) — carrega uma vez no app Dr. Herança.
 */
import { useEffect } from 'react';

const GA_MEASUREMENT_ID = 'G-2G7PF0D3G7';

export function GoogleTag() {
  useEffect(() => {
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
      return;
    }

    const loader = document.createElement('script');
    loader.async = true;
    loader.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

    const inline = document.createElement('script');
    inline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;

    document.head.appendChild(loader);
    document.head.appendChild(inline);
  }, []);

  return null;
}
